import { render, staticRenderFns } from "./TableRecords.vue?vue&type=template&id=1fe6f49f&scoped=true&lang=pug&"
import script from "./TableRecords.vue?vue&type=script&lang=ts&"
export * from "./TableRecords.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6f49f",
  null
  
)

export default component.exports